import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';
import {HttpClient} from "@angular/common/http";
import {NotificationService} from "./notification-service";

import 'rxjs/Rx';
import {ServiceVisit} from "../models/service-visit.model";
import * as moment from "moment";
import {DataService} from "./data-service";
import {Diagnostic} from "@ionic-native/diagnostic";
import {Geolocation} from "@ionic-native/geolocation";

@Injectable()
export class ActionService {

  constructor(public storage: Storage,
              public httpClient: HttpClient,
              public notification: NotificationService,
              public data: DataService,
              public diagnostic: Diagnostic,
              public geolocation: Geolocation) {
  }

  createServiceVisit(service: any, next_action: any = () => {
  }) {
    if (this.data.service_visits.hasOwnProperty(service.id)) {
      next_action();
    } else {
      this.notification.showConfirm('confirm', 'confirm_create_service_visit_message', 'yes', 'cancel', true, () => {
        this.notification.showLoading('starting_service', 'bubbles', true, () => {
          if (this.diagnostic.isLocationAuthorized) {
            this.geolocation.getCurrentPosition({
              maximumAge: 0,
              timeout: 6180,
              enableHighAccuracy: true
            }).then((data) => {
              this.data.service_visits[service.id] = new ServiceVisit(
                0,
                service.id,
                this.data.current_user.user_id,
                this.data.current_user.name,
                moment().toISOString(),
                null,
                '',
                '',
                '',
                '',
                data.coords.latitude,
                data.coords.longitude,
                null,
                null,
                [],
                [],
                [],
                {is_done: false},
                []
              );
              this.storage.set('service_visits', this.data.service_visits).then(next_action);
            }).catch((error) => {
              this.notification.showToast('unable_to_read_geo_location', true);
              this.data.service_visits[service.id] = new ServiceVisit(
                0,
                service.id,
                this.data.current_user.user_id,
                this.data.current_user.name,
                moment().toISOString(),
                null,
                '',
                '',
                '',
                '',
                null,
                null,
                null,
                null,
                [],
                [],
                [],
                {is_done: false},
                []
              );
              this.storage.set('service_visits', this.data.service_visits).then(next_action);
            });
          } else {
            if (this.data.settings.geolocation == 1) {
              this.notification.showAlert('failed', 'geo_location_off_not_authorised', 'ok', true);
            } else {
              this.notification.showConfirm('confirm', 'confirm_create_service_visit_message', 'yes', 'cancel', true, () => {
                this.data.service_visits[service.id] = new ServiceVisit(
                  0,
                  service.id,
                  this.data.current_user.user_id,
                  this.data.current_user.name,
                  moment().toISOString(),
                  null,
                  '',
                  '',
                  '',
                  '',
                  null,
                  null,
                  null,
                  null,
                  [],
                  [],
                  [],
                  {},
                  []
                );
                this.storage.set('service_visits', this.data.service_visits).then(next_action);
              });
            }
          }
        });
      });
    }
  }

  completeServiceVisit(service_visit: any, next_action: any = () => {
  }) {
    this.notification.showConfirm('confirm', 'confirm_upload_service_visit', 'yes', 'cancel', true, () => {
      this.notification.showLoading('uploading_service_visit', 'bubbles', true, () => {
        if (this.diagnostic.isLocationAuthorized) {
          this.geolocation.getCurrentPosition({
            maximumAge: 0,
            timeout: 6180,
            enableHighAccuracy: true
          }).then((data) => {
            service_visit.check_out_time = (service_visit.check_out_time == null ? moment().toISOString() : this.data.dateToISO(service_visit.check_out_time));
            service_visit.check_out_latitude = data.coords.latitude;
            service_visit.check_out_longitude = data.coords.longitude;
            service_visit.data.is_done = true;

            this.storage.get('service_visits').then((data) => {
              data[service_visit.service_id] = service_visit;
              this.storage.set('service_visits', data).then(() => {
                let url = this.data.settings.server_api_url + '/service-visit/create';
                this.httpClient.post(url, service_visit, {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'bearer ' + this.data.current_user.token
                  }
                }).map(
                  (response: Response) => response
                ).finally(
                  () => {
                    this.notification.hideLoading();
                  }
                ).subscribe(
                  (response) => {
                    this.notification.showToast('alert_service_visit_create_done', true);
                    service_visit.service_visit_id = response['id'];
                    next_action();
                  },
                  error => {
                    this.notification.showAlert('failed', 'alert_service_visit_create_failed', 'ok', true);
                  }
                )
              });
            });
          }).catch((error) => {
            service_visit.check_out_time = null;
            service_visit.check_out_latitude = null;
            service_visit.check_out_longitude = null;
            service_visit.data.is_done = false;
            this.notification.showToast('unable_to_upload_service_visit', true);
          });
        } else {
          if (this.data.settings.geolocation == 1) {
            this.notification.showAlert('failed', 'geo_location_off_not_authorised', 'ok', true);
          } else {
            this.notification.showConfirm('confirm', 'confirm_create_service_visit_message', 'yes', 'cancel', true, () => {
              service_visit.check_out_time = (service_visit.check_out_time == null ? moment().toISOString() : this.data.dateToISO(service_visit.check_out_time));
              service_visit.data.is_done = true;
              this.storage.get('service_visits').then((data) => {
                data[service_visit.service_id] = service_visit;
                this.storage.set('service_visits', data).then(() => {
                  let url = this.data.settings.server_api_url + '/service-visit/create';
                  this.httpClient.post(url, service_visit, {
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'bearer ' + this.data.current_user.token
                    }
                  }).map(
                    (response: Response) => response
                  ).finally(
                    () => this.notification.hideLoading()
                  ).subscribe(
                    (response) => {
                      this.notification.showToast('alert_service_visit_create_done', true);
                      service_visit.service_visit_id = response['id'];
                      next_action();
                    },
                    error => {
                      this.notification.showAlert('failed', 'alert_service_visit_create_failed', 'ok', true);
                    }
                  )
                });
              });
            });
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/action-service.ts